import BeneficiariesHeaderPanel from './BeneficiariesHeaderPanel';

export default BeneficiariesHeaderPanel;
